<style lang="less">
.daUserItem {
  a.k-user-logo {
    cursor: default;
  }
  
  &__me {
    @size:.20rem;
    position: absolute;
    top: -@size/2;
    right: 0;
    width: @size;
    height: @size;
    line-height: @size;
    background: #f00;
    border-radius: 50%;
    font-size: .12rem;
    color: #fff;
  }
}
</style>
<template>
  <div class="daUserItem" :class="{isMe: isMe}">
    <k-user-logo v-if="user" :src="user.logoSm" size="small" :lv="user.lvKey" />
    <k-user-logo
      v-else
      src="https://imgcdn-prd.pydp888.com/file/0/1/200003/20201028/46d4a35ab225281913d2eb94399e0f80.4_wenhao.png"
      size="small"
      lv="user"
    />
    <div v-if="isMe" class="daUserItem__me">我</div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: ['item'],
  computed: {
    ...mapGetters('account', ['myUid']),
    ...mapGetters('laxin', ['getUser']),
    inviteUid() {
      const { item } = this
      return item && item.inviteUid > 0 ? +item.inviteUid : 0
    },
    user() {
      return this.getUser(this.inviteUid)
    },
    isMe() {
      const { inviteUid, myUid } = this
      return myUid > 0 && inviteUid === myUid
    }
  }
}
</script>
